import { dateFormatter } from '@/grid/value-formatters/dateFormatter';
import { pregnantFormatter } from '@/grid/value-formatters/pregnantFormatter';
import {
  SUBFAMILY_FILTER_VALUES,
  SUBFAMILY_LABELS,
} from '@/utils/subfamilyValues';

import { ExportOptionValues, PregnantOptionValues } from './enums';

type ValueFormatterParams = { value: string | number | null | undefined };

function formatSubfamily(params: ValueFormatterParams) {
  if (params.value == null) return '';
  return SUBFAMILY_LABELS[String(params.value)] ?? params.value;
}

const subfamilyColumn = {
  field: 'breed.subFamily',
  headerName: 'Species',
  filter: 'agSetColumnFilter',
  filterParams: {
    values: SUBFAMILY_FILTER_VALUES,
    valueFormatter: formatSubfamily,
  },
  valueFormatter: formatSubfamily,
};

export const columnDefsV2 = [
  {
    field: 'name',
    headerName: 'Donor Name (Tag)',
    filter: 'agTextColumnFilter',
  },
  {
    field: 'breed.code',
    headerName: 'Breed',
    filter: 'agTextColumnFilter',
  },
  subfamilyColumn,
  {
    field: 'owner.code',
    headerName: 'Ranch',
    filter: 'agTextColumnFilter',
  },
  {
    field: 'registrationNumber',
    headerName: 'Reg #',
    filter: 'agTextColumnFilter',
  },
  {
    field: 'tattoo',
    headerName: 'Ear Tag',
    filter: 'agTextColumnFilter',
  },
  {
    field: 'metalTag',
    headerName: 'Metal/RFID Tag',
    filter: 'agTextColumnFilter',
  },
  {
    field: 'received',
    headerName: 'Received',
    valueFormatter: dateFormatter,
    filter: 'agDateColumnFilter',
  },
  {
    field: 'pregnant',
    headerName: 'Pregnant',
    valueFormatter: pregnantFormatter,
    filter: 'agSetColumnFilter',
    filterParams: {
      values: [PregnantOptionValues.No, PregnantOptionValues.Yes],
      valueFormatter: (params: ValueFormatterParams) => {
        const v = Number(params.value);
        if (v === PregnantOptionValues.No) return 'No';
        if (v === PregnantOptionValues.Yes) return 'Yes';
        return '';
      },
    },
  },
  {
    field: 'yard.name',
    headerName: 'Yard',
    filter: 'agTextColumnFilter',
  },
  {
    field: 'ranchTag',
    headerName: 'Ranch Tag',
    filter: 'agTextColumnFilter',
  },
  {
    field: 'ship',
    headerName: 'Ship Date',
    valueFormatter: dateFormatter,
    filter: 'agDateColumnFilter',
  },
  {
    field: 'lastActivity',
    headerName: 'Last Activity',
    filter: 'agTextColumnFilter',
  },
  {
    field: 'activityDate',
    headerName: 'Activity Date',
    valueFormatter: dateFormatter,
    filter: 'agDateColumnFilter',
  },
  {
    field: 'createdOn',
    headerName: 'Created On',
    valueFormatter: dateFormatter,
    filter: 'agDateColumnFilter',
  },
  {
    field: 'birth',
    headerName: 'Birth Date',
    valueFormatter: dateFormatter,
    filter: 'agDateColumnFilter',
  },
  {
    field: 'exportDonor',
    headerName: 'Export Donor',
    valueFormatter: (params: ValueFormatterParams) => {
      const v = Number(params.value);
      if (v === ExportOptionValues.No) return 'No';
      if (v === ExportOptionValues.Yes) return 'Yes';
      return '';
    },
    filter: 'agSetColumnFilter',
    filterParams: {
      values: [ExportOptionValues.No, ExportOptionValues.Yes],
      valueFormatter: (params: ValueFormatterParams) => {
        const v = Number(params.value);
        if (v === ExportOptionValues.No) return 'No';
        if (v === ExportOptionValues.Yes) return 'Yes';
        return '';
      },
    },
  },
  {
    field: 'programName',
    headerName: 'Program Name',
    filter: 'agTextColumnFilter',
  },
];
